import React, { useState } from 'react';
import axios from 'axios';
import styles from '../styles/Connexion.module.css';
import relief from '../styles/Relief.module.css'

import { useAuthContext } from '../context/AuthContext';

const RegisterForm = ({ onRegisterSuccess }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');

    const [showRegister, setShowRegister] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { login } = useAuthContext();



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        if (formData.password !== formData.confirmPassword) {
            setError('Les mots de passe ne correspondent pas');
            return false;
        }
        if (formData.password.length < 6) {
            setError('Le mot de passe doit contenir au moins 6 caractères');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!validateForm()) return;

        try {
            await axios.post('https://api.poketask.fr/api/register', {
                username: formData.username,
                password: formData.password
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });

            onRegisterSuccess();
        } catch (error) {
            console.error('Error registering user:', error);
            setError(error.response?.data?.message || 'Erreur lors de la création du compte');
        }
    };

    return (
        <div className={styles.connection_container}>
            <div className={styles.container}>
                <form onSubmit={handleSubmit}>
                    <div className={styles.register_container}>
                        <div className={`${styles.title}`}>Inscription</div>
                        <div className={`${styles.inputs} `}>
                            {error && <p className={styles.error}>{error}</p>}
                            <div className={styles.item}>

                                <div className={styles.input_container}>
                                <img src="/assets/icons/user.svg" alt="user" />
                                    <input
                                        type="text"
                                        name="username"
                                        placeholder="Nom d'utilisateur"
                                        value={formData.username}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className={styles.item}>
                            <div className={styles.input_container}>
                                    <div className={styles.password_container}>
                                        <img src="/assets/icons/lock.svg" alt="lock" />
                                        <input
                                            type={showPassword ? "text" : "password"} // type de l'input password ou text 
                                            name="password"
                                            placeholder="Mot de passe"
                                            value={formData.password} // valeur de l'input password
                                            onChange={handleChange} // fonction de changement de la valeur de l'input password
                                            required // obligatoire
                                        />


                                        <button 
                                            type="button"
                                            className={styles.toggle_password} // classe de l'image
                                            onClick={() => setShowPassword(!showPassword)} // fonction de changement du type de l'input password
                                        >
                                            <img 
                                                src={`/assets/icons/${showPassword ? 'eye-off' : 'eye'}.svg`} // image de l'input password

                                                alt={showPassword ? "Masquer" : "Afficher"}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.input_container}>
                                <img src="/assets/icons/lock.svg" alt="lock" />
                                <input
                                    type={showConfirmPassword ? "text" : "password"} // type de l'input password ou text 
                                    name="confirmPassword"
                                    placeholder="Confirmer le mot de passe"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    required
                                    />
                                    <button 
                                            type="button"
                                            className={styles.toggle_password} // classe de l'image
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)} // fonction de changement du type de l'input password
                                        >
                                            <img 
                                                src={`/assets/icons/${showConfirmPassword ? 'eye-off' : 'eye'}.svg`} // image de l'input password

                                                alt={showConfirmPassword ? "Masquer" : "Afficher"}
                                            />
                                    </button>
                                </div>
                            </div>
                            <div className={styles.item}>
                                <div  className={`${styles.input_container}`} style={{border: 'none'}}>
                                    <button className={styles.buttonContainer}  type="submit">
                                        <div className={`${styles.connect_button}`}>S'inscrire</div>
                                    </button>
                                </div>
                            </div>
                            <div className={styles.separatorGroup}>
                                <div className={styles.separator}></div>
                                <p>ou</p>
                                <div className={styles.separator}></div>
                            </div>
                            <div className={styles.item}> 
                                <div  className={`${styles.input_container}`} style={{border: 'none', backgroundColor: 'transparent', height: '1px'}}>
                                    <button className={styles.buttonContainer} onClick={onRegisterSuccess}>
                                        <div className={`${styles.register_button}`}>Vous avez déjà un compte ?</div>
                                    </button>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegisterForm;